import { GET_SUCCESS_STORIES } from './constants';

export function loadSuccessStories() {
  return dispatch => dispatch({
    type: GET_SUCCESS_STORIES,
    request: {
      method: 'GET',
      endpoint: 'success_stories/'
    }
  });
}



// WEBPACK FOOTER //
// ./src/redux/SuccessStories/actions.js